// removed by extract-text-webpack-plugin
module.exports = {"AllocationCategory":"AllocationCategory__AllocationCategory__1fLgZ","greenBorder":"AllocationCategory__greenBorder__3nXHR","assetHandle":"AllocationCategory__assetHandle__1_kX_","title":"AllocationCategory__title__cqfAI","assets":"AllocationCategory__assets__1iNHM","subAsset":"AllocationCategory__subAsset__2cpFd","collapsed":"AllocationCategory__collapsed__2fod4"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/AllocationCategory/AllocationCategory.css
// module id = 497
// module chunks = 0